(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let resizeObserver;
  let mutationObserver;
  let raf;

  function isHTMLElement(element) {
    return element instanceof HTMLElement;
  }

  function isVisible(element) {
    if (!isHTMLElement(element)) return false;

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getLayoutParent(block) {
    return block.closest('.layout-panel-flex');
  }

  function getDirectLayoutChild(layoutParent, block) {
    return Array.from(layoutParent.children).find((child) => {
      return child === block || child.contains(block);
    });
  }

  function getSiblingHeight(block) {
    const layoutParent = getLayoutParent(block);

    if (!layoutParent) {
      return null;
    }

    const directChild = getDirectLayoutChild(layoutParent, block);

    if (!directChild) {
      return null;
    }

    const siblings = Array.from(layoutParent.children).filter((sibling) => {
      if (sibling === directChild) return false;
      if (!isHTMLElement(sibling)) return false;
      if (sibling.matches('[data-rotated-mobile-lock]')) return false;
      if (sibling.querySelector('[data-rotated-mobile-lock]')) return false;

      return isVisible(sibling);
    });

    if (!siblings.length) {
      return null;
    }

    return Math.max(
      ...siblings.map((sibling) => sibling.getBoundingClientRect().height)
    );
  }

  function resetBlock(block) {
    block.style.removeProperty('--rotated-text-mobile-lock-height');
    block.style.removeProperty('--rotated-text-mobile-font-size');
  }

  function fitTextToHeight(block, targetHeight) {
    const textElement = block.firstElementChild;

    if (!textElement || !isHTMLElement(textElement)) {
      return;
    }

    resetBlock(block);

    block.style.setProperty(
      '--rotated-text-mobile-lock-height',
      `${Math.round(targetHeight)}px`
    );

    const computed = window.getComputedStyle(textElement);
    const originalFontSize = parseFloat(computed.fontSize);

    if (!originalFontSize || Number.isNaN(originalFontSize)) {
      return;
    }

    let fittedFontSize = originalFontSize;

    for (let i = 0; i < 4; i += 1) {
      block.style.setProperty(
        '--rotated-text-mobile-font-size',
        `${fittedFontSize}px`
      );

      const textHeight = textElement.getBoundingClientRect().height;

      if (!textHeight || textHeight <= targetHeight) {
        break;
      }

      fittedFontSize = Math.max(
        8,
        fittedFontSize * (targetHeight / textHeight) * 0.94
      );
    }

    block.style.setProperty(
      '--rotated-text-mobile-font-size',
      `${Math.round(fittedFontSize)}px`
    );
  }

  function updateRotatedTextLocks() {
    const lockedBlocks = document.querySelectorAll('[data-rotated-mobile-lock]');

    lockedBlocks.forEach((block) => {
      if (!isHTMLElement(block)) return;

      if (!mobileQuery.matches) {
        resetBlock(block);
        return;
      }

      const targetHeight = getSiblingHeight(block);

      if (!targetHeight) {
        resetBlock(block);
        return;
      }

      fitTextToHeight(block, targetHeight);
    });
  }

  function scheduleUpdate() {
    window.cancelAnimationFrame(raf);
    raf = window.requestAnimationFrame(updateRotatedTextLocks);
  }

  function observeImages() {
    document.querySelectorAll('img').forEach((image) => {
      if (image.complete) return;
      image.addEventListener('load', scheduleUpdate, { once: true });
    });
  }

  function initRotatedTextLocks() {
    scheduleUpdate();
    observeImages();

    if (resizeObserver) {
      resizeObserver.disconnect();
    }

    resizeObserver = new ResizeObserver(scheduleUpdate);

    document
      .querySelectorAll('.layout-panel-flex, [data-rotated-mobile-lock], img')
      .forEach((element) => {
        resizeObserver.observe(element);
      });

    if (mutationObserver) {
      mutationObserver.disconnect();
    }

    mutationObserver = new MutationObserver(scheduleUpdate);

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  }

  document.addEventListener('DOMContentLoaded', initRotatedTextLocks);
  window.addEventListener('load', initRotatedTextLocks);
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('pageshow', scheduleUpdate);

  document.addEventListener('shopify:section:load', initRotatedTextLocks);
  document.addEventListener('shopify:block:select', scheduleUpdate);
  document.addEventListener('shopify:block:deselect', scheduleUpdate);
  document.addEventListener('shopify:section:select', scheduleUpdate);

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', scheduleUpdate);
  }
})();